import { KeyConstructor } from './keyConstructor';
const SEARCH_KEY = 'search';
const POST_KEY = 'post';
const POSTS_KEY = 'posts';
const TAGS_KEY = 'tags';
const POST_REACTION_PARTICIPANTS_KEY = 'postReactionParticipants';
const POST_TYPE_KEY = 'postType';
const POST_TYPES_KEY = 'postTypes';
export const getSearchKey = KeyConstructor(SEARCH_KEY);
export const getPostKey = KeyConstructor(POST_KEY);
export const getPostsKey = KeyConstructor(POSTS_KEY);
export const getTagsKey = KeyConstructor(TAGS_KEY);
export const getPostReactionParticipantsKey = KeyConstructor(POST_REACTION_PARTICIPANTS_KEY);
export const getPostTypeKey = KeyConstructor(POST_TYPE_KEY);
export const getPostTypesKey = KeyConstructor(POST_TYPES_KEY);
//# sourceMappingURL=post.key.js.map